export default class Carousel{
    constructor(sliderBox, childClass, timeHideAndSeek = 8) {
        this.carousel = document.getElementById(sliderBox)
        this.slider = (this.carousel) ? this.carousel.children[0] : null
        this.timeHideAndSeek = timeHideAndSeek;

        if(this.slider){

            this.relevantPosts = this.carousel.getElementsByClassName(childClass)
            this.isRendering = false
            if(this.relevantPosts && this.relevantPosts.length > 1) {

                this.current_article_index = 0
                this.show()

                this.left = this.appendCommand("left")
                this.carousel.appendChild(this.left)
                this.left.onclick  = () => this.prev()

                this.right = this.appendCommand("right")
                this.carousel.appendChild(this.right)
                this.right.onclick = () => this.next()

                if(this.timeHideAndSeek)
                    this.loopHideAndSeek()
            }
        }
    }

    loopHideAndSeek(iteration = 0) {
        iteration++
        window.setTimeout(() => {
            this.hideAndSeek(iteration)
        }, this.timeHideAndSeek * 1000 * iteration)
    }

    hideAndSeek(iteration) {
        if(this.isInitialPosition()){
            this.slider.style.transform = "translate(-5%)";
            window.setTimeout(() => {
                if(this.isInitialPosition()){
                    this.slider.style.transform = "translate(0)";
                }
            }, 1000)
        }
        this.loopHideAndSeek(iteration)
    }

    isInitialPosition() {
        return !this.current_article_index && !this.carousel.scrollLeft;
    }

    appendCommand(direction) {
        var node = document.createElement("div");
        node.className = " "+direction+"-button action-button container h-100";
        node.innerHTML = '<div class="row h-100 justify-content-center align-items-center"><i class="icon icon-cheveron-down icon-cheveron-down-'+direction+'"></i></div>'
        return node
    }

    show() {
        var move = (this.current_article_index * 100) / this.relevantPosts.length +"%";
        var translate = "translate(-"+move+")";
        this.slider.style.transform = translate;
        this.relevantPosts[this.current_article_index].classList.add("visible")
    }
  
    prev(){
        this.current_article_index = this.current_article_index ? this.current_article_index - 1 : this.relevantPosts.length -1
        this.show()
    }

    next(){
        this.current_article_index = (this.current_article_index + 1) % this.relevantPosts.length
        this.show()
    }
}


// WEBPACK FOOTER //
// ./scripts/util/Carousel.js